import { ResponseCurrencyType, RequestCurrencyType } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { CurrencyTypeActions } from '../actions';
import { currencyTypeTypes } from '../../shared/enums';

export interface CurrencyTypeState {
    response: ResponseCurrencyType;
    request: RequestCurrencyType;
    error: any;
}

export const currencyTypeInitialState: CurrencyTypeState = {
    response: null,
    request: null,
    error: null
};

const _currencyTypeReducer = createReducer(
    currencyTypeInitialState,

    on(CurrencyTypeActions.getcurrencyType, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(CurrencyTypeActions.getcurrencyTypeSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(CurrencyTypeActions.getcurrencyTypeError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(CurrencyTypeActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function currencyTypeReducer(state, action) {
    if (action.type === currencyTypeTypes.CONFIG_REQUEST_MANAGER) {
        state = undefined;
    }
    return _currencyTypeReducer(state, action);
}
